import Frames from "@fae/source/engine/animating/Frames.js"

export default {
    "static": require("./knight-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 100,
            "images": [
                require("./knight-idle-0.png"),
                require("./knight-idle-0.png"),
                require("./knight-idle-0.png"),
                require("./knight-idle-0.png"),
                require("./knight-idle-0.png"),
                require("./knight-idle-0.png"),
                require("./knight-idle-0.png"),
                require("./knight-idle-0.png"),
                require("./knight-idle-1.png"),
                require("./knight-idle-2.png"),
                require("./knight-idle-3.png"),
                require("./knight-idle-4.png"),
                require("./knight-idle-5.png"),
                require("./knight-idle-6.png"),
                require("./knight-idle-7.png"),
                require("./knight-idle-7.png"),
                require("./knight-idle-7.png"),
                require("./knight-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "keytime": 400,
            "tweentime": 100,
            "images": [
                require("./knight-selected-2.png"),
                require("./knight-selected-3.png"),
                require("./knight-selected-4.png"),
                require("./knight-selected-4.png"),
                require("./knight-selected-4.png"),
                require("./knight-selected-4.png"),
                require("./knight-selected-4.png"),
                require("./knight-selected-4.png"),
                require("./knight-selected-4.png"),
                require("./knight-selected-5.png"),
                require("./knight-selected-6.png"),
                require("./knight-selected-7.png"),
                require("./knight-selected-0.png"),
                require("./knight-selected-0.png"),
                require("./knight-selected-0.png"),
                require("./knight-selected-0.png"),
                require("./knight-selected-1.png"),
            ]
        })
    },
}
